import { Input } from "@chakra-ui/react";

export default function TokenInput() {
  return (
    <Input
      width="100%"
      py="10px"
      px="16px"
      bg="primary"
      color="white"
      fontSize="14px"
      lineHeight="1.14"
      letterSpacing="0.15px"
      border="solid 1px rgba(255, 255, 255, 0.4)"
      borderRadius="24px"
      _placeholder={{
        color: "rgba(255, 255, 255, 0.7)",
        fontSize: "12px"
      }}
      _focus={{
        borderColor: "white"
      }}
    />
  );
}
